module.exports = __webpack_public_path__ + "media/images/archive-a5f28f6592d203e3b96a0a7346f48f02.svg";